import { render, staticRenderFns } from "./PricingLogicForm.vue?vue&type=template&id=45c447d1"
import script from "./PricingLogicForm.vue?vue&type=script&lang=js"
export * from "./PricingLogicForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports